export default function validateProjectDescription(description) {
  const minLength = 30;   // Enough to be meaningful
  const maxLength = 600;  // Prevent essay-length walls

  if (!description || description.trim().length < minLength) {
    return { valid: false, reason: "too short" };
  }

  if (description.length > maxLength) {
    return { valid: false, reason: "too long" };
  }

  return { valid: true };
}
